import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslocoModule } from '@jsverse/transloco';
import { FormBaseComponent } from '@anihis/shared/src/shared/base-components/form-base.component';

@Component({
  selector: 'anihis-analysis-points-finding',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    TranslocoModule,
  ],
  templateUrl: './analysis-points.component.html',
  styleUrls: ['./analysis-points.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnalysisPointsFindingComponent
  extends FormBaseComponent
  implements OnInit
{
  @Output() formChange = new EventEmitter<any>();

  override ngOnInit(): void {
    this.form = this.fb.group({
      specificGravity: [''],
      nitrites: [''],
      ph: [''],
      proteins: [''],
      glucose: [''],
      urobilinogen: [''],
      bilirubin: [''],
      ketones: [''],
      leukocytes: [''],
      bloodErythrocytes: [''],
      sediment: [''],
      veterinarianName: [''],
    });

    // Emit initial and subsequent changes
    this.formChange.emit(this.form.value);
    this.subs.sink = this.form.valueChanges.subscribe((v) =>
      this.formChange.emit(v),
    );

    super.ngOnInit();
  }
}
